import {
  GET_SUBSCRIPTION_RULES,
} from 'constants/subscriptionRules';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_SUBSCRIPTION_RULES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
